module.exports = __webpack_public_path__ + "img/keji.ab7376c2.png";